import React from 'react';
import DataGrid from '../../components/Common/DataGrid';
import { Async, EmptyState, Kpi, KpiGrid, PageHeader, Panel } from '../ui';
import useFetch from '../useFetch';

/** Read-only view of what finOS is currently offering through the reseller sites. */
const Products = () => {
  const cats = useFetch('/products/categories');
  const stats = useFetch('/products/stats');
  return (
    <>
      <PageHeader eyebrow="Platform" title="finOS products" />
      <Async state={stats}>
        {(s) => (
          <KpiGrid>
            <Kpi label="Providers" value={s.total_banks} note="Banks and insurers on finOS" />
            <Kpi label="Products" value={s.total_products} note="Shown on partner sites" />
          </KpiGrid>
        )}
      </Async>
      <Panel title="Categories" subtitle="Resellers choose from these when they sign up. Products come live from finOS.">
        <Async state={cats}>
          {(rows) => rows.length === 0 ? (
            <EmptyState title="No categories">finOS did not return any categories.</EmptyState>
          ) : (
            <DataGrid
              simple
              rows={rows}
              order={[[0, 'asc']]}
              columns={[
                { title: 'Category', render: (c) => <><strong>{c.label}</strong><small>{c.id}</small></>, value: (c) => c.label },
                { title: 'Products', numeric: true, render: (c) => c.product_count ?? 0, value: (c) => c.product_count ?? 0 },
                { title: 'Source', render: (c) => (c.source === 'finos' ? 'Live from finOS' : 'Default list (finOS unreachable)'), value: (c) => c.source },
              ]}
            />
          )}
        </Async>
      </Panel>
    </>
  );
};

export default Products;
